//响应码
export function resqCode(code){
    switch(code){
        case 0 : return '成功';break;
        case 10000 : return '用户未登录';break;
        case 10010 : return '无效认证令牌';break;
        case 10020 : return '令牌已过期';break;
        case 10030 : return '用户已被禁用';break;
        case 11000 : return '设备未登录';break;
        case 11010 : return '无效设备令牌';break;
        case 11020 : return '设备令牌已过期';break;
        case 11030 : return '设备已被禁用';break;
        case 20000 : return '用户名或密码错误';break;
        case 20010 : return '用户未注册';break;
        case 20020 : return '没有此用户';break;
        case 20030 : return '没有此后台用户';break;
        case 20040 : return '用户已存在';break;
        case 20050 : return '后台用户已存在';break;
        case 20060 : return '无效用户名';break;
        case 20070 : return '用户名已存在';break;
        case 20080 : return '没有此权限';break;
        case 30010 : return '路由不存在';break;
        case 30030 : return '无效参数';break;
        case 30040 : return '请求频繁';break;
        case 30050 : return '访问被拒绝';break;
        case 30060 : return '无效短信验证码';break;
        case 40000 : return '操作他人数据';break;
        case 40010 : return '无效验证码';break;
        case 40020 : return '资源不存在';break;
        case 40030 : return '数据库已初始化';break;
        case 50000 : return 'Web服务器错误';break;
        case 70010 : return 'Mysql错误';break;
        case 70020 : return 'Redis错误';break;
        case 80000 : return '第三方API错误';break;
        case 80100 : return '阿里云API错误';break;
        case 80200 : return '微信API错误';break;
        case 90000 : return '未知错误';break;
    }
}

//转换时间格式
export function formatime(UTCtime){ 
    if(UTCtime){
        var date = new Date(UTCtime)
        var year = date.getFullYear();
        var month = (date.getMonth()+1) < 10 ? '0'+(date.getMonth()+1) : (date.getMonth()+1);
        var day = date.getDate() < 10 ? '0'+ date.getDate() : date.getDate();
        var hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
        var min = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
        var seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
        return year+'/'+month + '/'+ day + ' ' + hour + ':' + min + ':' + seconds;
    }else{
        return '无';
    }
}

//转换时间格式
export function formaDate(UTCtime){ 
    if(UTCtime){
        var date = new Date(UTCtime)
        var year = date.getFullYear();
        var month = (date.getMonth()+1) < 10 ? '0'+(date.getMonth()+1) : (date.getMonth()+1);
        var day = date.getDate() < 10 ? '0'+ date.getDate() : date.getDate();
        return year+'/'+month + '/'+ day ;
    }else{
        return '无';
    }
}

//获取常量
var constJson = require('../../static/constJson.json')
export function getConst(name,type,constSuc){
    var constJsonData = constJson.data
    for(let cj in constJsonData){
        var constPublic = []
        if(cj == name){
            for(var nt in constJsonData[cj]){
                var cpObj = {}
                cpObj.value = nt;
                cpObj.label = constJsonData[cj][nt];
                constPublic.push(cpObj)
            }
            if(type == 'select'){
                var all = {
                    value:'all',
                    label:'全部'
                }
                constPublic.push(all)
            }
            return constSuc(constPublic)
        }
    }
}

//请求
import request from "./request";
export function requestPublic(url,action,data,success,error,fail){
    if(action == 'get'){
        request.get(url).then(res=>{
            if(res.code == 0 && res.status == 200){
                return success(res)
            }else{
                return error(res)
            }
        },failRes=>{
            return fail('网络不通！请检查网络')
        })
    }else if(action == 'post'){
        request.post(url,data).then(res=>{
            if(res.code == 0 && res.status == 200){
                return success(res)
            }else{
                return error(res)
            }
        },failRes=>{
            return fail('网络不通！请检查网络')
        })
    }
}

//数组去重
export function unique(arr){ 
    if (!Array.isArray(arr)) {
        return;
    }
    var array =[];
    for(var i = 0; i < arr.length; i++) {
            if( !array.includes( arr[i]) ) {//includes 检测数组是否有某个值
                    array.push(arr[i]);
            }
    }
    return array
}

//把data转为formData
export function json2Form(json){ //参数data转formData
    var str = [];
    for(var p in json){
        str.push(encodeURIComponent(p)+"="+decodeURIComponent(json[p]))
    }
    return str.join('&')
}

//过滤参数不为空
export function checkIsNull(checkNum){  
    var checknotNull = {}
    for(let i in checkNum){
        if(checkNum[i]){
            checknotNull[i] = checkNum[i]
        }
    }
    return checknotNull
}

//查询充电站
export function getDeviceGroup(getDGarr){ //获取充电站
    requestPublic('/device-group/do/query','get',null,devRes=>{
        if(devRes.code == 0 && devRes.status == 200){
            var devcieGroupArr = [];
            var devResData = devRes.data
            for(var d = 0; d < devResData.length; d ++){
                var deviceGroupObj = {};
                deviceGroupObj.value = devResData[d].id;
                deviceGroupObj.label = devResData[d].name;
                devcieGroupArr.push(deviceGroupObj)
            }
            return getDGarr(devcieGroupArr);
        }
    })
}

export function getMyDeviceGroup(getDGarr){ //获取我的充电站
    requestPublic('/my-device-group/do/query','get',null,devRes=>{
        if(devRes.code == 0 && devRes.status == 200){
            var devcieGroupArr = [];
            var devResData = devRes.data
            for(var d = 0; d < devResData.length; d ++){
                var deviceGroupObj = {};
                deviceGroupObj.value = devResData[d].id;
                deviceGroupObj.label = devResData[d].name;
                devcieGroupArr.push(deviceGroupObj)
            }
            return getDGarr(devcieGroupArr);
        }
    })
}

//遍历Excel文档
export function uploadCardFile(file){
    let newFile = JSON.parse(file)
    let cardArr = []
    for(let n = 0; n < newFile.length; n ++){
        let cobj = {}
        if(newFile[n].卡编号){
            cobj.code = newFile[n].卡编号
        }
        if(newFile[n].卡片名称){
            cobj.name = newFile[n].卡片名称
        }
        if(newFile[n].工本费){
            cobj.price = newFile[n].工本费
        }
        if(newFile[n].备注){
            cobj.remark = newFile[n].备注
        }
        cardArr.push(cobj)
    }
    return new Promise((resolve,reject)=>{
        for(let c = 0; c < cardArr.length; c ++){
            var isTrue = isEmptyObj(cardArr[c])
        }
        if(!isTrue){
            let isCardAddTrue = addCradArr(cardArr)
            resolve(isCardAddTrue)
        }else{
            reject('请导入正确的数据！')
        }
    })
    
}
export function isEmptyObj(obj) {
    for (var key in obj) {
      return false;
    }
    return true;
}
function addCradArr(arr){
    let url = '/card/do/add'
    let arrLast = arr[arr.length - 1]
    for(let a = 0; a < arr.length; a ++){
        if(arr[a] == arrLast){
            requestPublic(url,'post',arr[a],res=>{
                console.log(res)
            })
            return true;
        }else{
            requestPublic(url,'post',arr[a],res=>{
                console.log(res)
            }) 
        }
    }
}

export function editInfoFunc(data){
    for(let item in data){
        if(!data[item] && data[item] != 0){
            data[item] = ''
        }
    }
    return data;
}

export function getMuserId(muserId,url){
    return new Promise((resolve,reject)=>{
        requestPublic(url+'?id='+muserId,'get',null,muserRes=>{
            resolve(muserRes.data.identifier)
        },error=>{
            reject(error)
        },fail=>{
            reject(fail)
        })
    })
}

export function getMerchantId(muserId,url){
    return new Promise((resolve,reject)=>{
        requestPublic(url+'?id='+muserId,'get',null,muserRes=>{
            resolve(muserRes.data.name)
        },error=>{
            reject(error)
        },fail=>{
            reject(fail)
        })
    })
}

export function turnTimeType(str,time,dateNum = 1){
    if(time){
        let year,month,dateN,oldTime;
        if(str == 'from'){
            year = time.getFullYear()
            month = time.getMonth()
            dateN = time.getDate()
        }else if(str == 'end'){
            dateN = time.getDate()+dateNum
            year = time.getFullYear()
            month = time.getMonth()
        }
        oldTime = new Date(year,month,dateN)
        let utcTime = oldTime.toISOString()
        return utcTime
    }else{
        return ''
    }
}

/**数组中的id */
export function isTheSameOldData(data,oldData){
    let obj = {}
    for(let i in data){
        for(let o in oldData){
            if(i == o){
                if(data[i] != oldData[o]){
                    obj[i] = data[i]
                }
            }
        }
    }
    return obj
}

export function isTheSameOldArrayData(data,oldData){
    let arr = []
    data = unique(data)
    if(data.length >= oldData.length){
        for(let i = 0; i < data.length; i ++){
            let oo = oldData.find(o=>o==data[i])
            if(!oo){
                arr.push(data[i])
            }
            /*for(let o = 0; o < oldData.length; o ++){
                if(data[i] != oldData[o]){
                    arr.push(data[i])
                }
            }*/
        }
    }else if(data.length < oldData.length){
        for(let i = 0; i < oldData.length; i ++){
            let oo = data.find(o=>o==oldData[i])
            if(!oo){
                arr.push(oldData[i])
            }
            /*for(let o = 0; o < oldData.length; o ++){
                if(data[i] != oldData[o]){
                    arr.push(data[i])
                }
            }*/
        }
    }
    if(arr.length > 0){
        return true
    }else if(arr.length == 0){
        return false
    }
}

/**数组中过滤出的id */
export function isResourceAllArray(data){
    let arr = []
    if(data.length > 0){
        //let isApiArray = data.filter(a=>a.type == 'api')
        let isNotApiArray = data.filter(a=>a.type != 'api' && a.is_bound == 1)
        /*for(let ia of isApiArray){
            arr.push(ia.id)
        }*/
        if(isNotApiArray.length > 0){
            resourceChildren(arr,isNotApiArray)
        }
    }
    return unique(arr)
}

function resourceChildren(arr,cdata){
    for(let c of cdata){
        arr.push(c.id)
        if(c.children.length > 0){
            arr.concat(resourceGrandChildren(arr,c.children))
        }
    }
}

function resourceGrandChildren(carr,gcdata){
    let isBound = gcdata.filter(g=>g.is_bound == 1)
    for(let g of isBound){
        carr.push(g.id)
        if(g.children.length>0){
            resourceGrandChildren(carr,g.children)
        }
    }
}

export function getTime(){
    let n = new Date()
    var hour,min,sec;
    hour = n.getHours() < 10 ? '0'+n.getHours() : n.getHours()
    min = n.getMinutes() < 10 ? '0'+n.getMinutes() : n.getMinutes()
    sec = n.getSeconds() < 10 ? '0'+n.getSeconds() : n.getSeconds();
    return hour+':'+min+':'+sec
}

import store from "../store";
import menuTree from './treeMenu'
export function refrashMenuTree(){
    return new Promise((resolve,reject)=>{
        requestPublic('/my-resource/do/query','get',null,treeRes=>{
            let menuSuc = menuTree(treeRes.data)
            localStorage.setItem('menu',JSON.stringify(menuSuc.reverse()))
            store.commit('setMenus',JSON.parse(localStorage.getItem('menu')))
            var childObj = {}
            for(let r of treeRes.data){
                if(r.name == '首页'){
                    if(r.children.length > 0){
                        let child = r.children
                        childObj = ishomeTag(child)
                    }
                }
            }
            childObj.isTrue = true
            resolve(childObj)
        },error=>{
            reject(error)
        })
    })
}
function ishomeTag(childArr){
    let obj = {}
    for(let i of childArr){
        if(i.code == 'home'){
            obj[i.code] = true
        }else if(i.code == 'myhome'){
            obj[i.code] = true
        }
    }
    return obj
}

//判断是否有自己
export function isHaveMine(newData){
    let hasThisUser = newData.find(n=>n === localStorage.getItem('user_id'))
    if(hasThisUser){
        return true
    }else{
        return false
    }
}

export function isDeleteAim(row){
    const arr = []
    arr.push(row.id)
    if(row.children.length > 0){
        let childrenArr = row.children
        for(let i of childrenArr){
            arr.push(i.id)
            if(i.children.length>0){
                isDeleteChildAim(i.children,arr)
            }
        }
    }
    return arr
}

function isDeleteChildAim(childArr,arr){
    for(let c of childArr){
        arr.push(c.id)
        if(c.children.length > 0){
            isDeleteChildAim(c.children,arr)
        }
    }
}

export function uniqueObj(arr){
    let newobj = {}; 
    arr = arr.reduce((preVal, curVal) => {
        newobj[curVal.name] ? '' : newobj[curVal.name] = preVal.push(curVal); 
        return preVal
    }, [])
    return arr
} 

export function getQuery(name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
    var r = window.location.search.substr(1).match(reg);
    if (r != null) {
        return unescape(r[2]);
    }
    return null;
}


/*
** randomWord 产生任意长度随机字母数字组合
** randomFlag-是否任意长度 min-任意长度最小位[固定位数] max-任意长度最大位
** xuanfeng 2014-08-28
*/
 
export function randomWord(randomFlag, min, max){
    var str = "",
        range = min,
        arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z','_','/','*'];
 
    // 随机产生
    if(randomFlag){
        range = Math.round(Math.random() * (max-min)) + min;
    }
    for(var i=0; i<range; i++){
        let pos = Math.round(Math.random() * (arr.length-1));
        str += arr[pos];
    }
    return str;
}

//校验密码强度---沒有匹配到以下級別就提示
export function checkPassWord(value){
    // 0： 表示第一个级别 1：表示第二个级别 2：表示第三个级别
    // 3： 表示第四个级别 4：表示第五个级别
    var arr=[],array=[1,2,3,4];
    if(value.length < 6){//最初级别
        return 0;
    }
    if(/\d/.test(value)){//如果用户输入的密码 包含了数字
        arr.push(1);
    }
    if(/[a-z]/.test(value)){//如果用户输入的密码 包含了小写的a到z
        arr.push(2);
    }
    if(/[A-Z]/.test(value)){//如果用户输入的密码 包含了大写的A到Z
        arr.push(3);
    }
    if(/\W/.test(value)){//如果是非数字 字母 下划线
        arr.push(4);
    }
    for(var i=0;i<array.length;i++){
        if(arr.indexOf(array[i])==-1){
            return array[i];
        }
    }
}


// WEBPACK FOOTER //
// ./src/utils/resqCode.js